export default {
  questionTitle: 'Contact us ?',
  contactUsTitle: 'Can’t find the answers you’re looking for?',
  contactUsText: 'We’re here to help.',
  linkText: 'Contact us',
};
